export default __webpack_public_path__ + "static/media/img_12.b651b4ae.jpg";